import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
import ErrorWithCause from '@helpers/ErrorWithCause';
const getSuggestedTournaments = async (gameKey, limit) => {
    var _a;
    const useLegacyEndpoint = ((_a = process.env.REPEAT_USE_LEGACY_SUGGESTED_TOURNAMENTS_ENDPOINT) !== null && _a !== void 0 ? _a : 'true') === 'true';
    const requestUrl = useLegacyEndpoint
        ? `${SYMFONY_API_BASE_URL}/api/tournaments/v1/suggested`
        : `${process.env.REPEAT_TOURNAMENT_SERVICE_URL}/tournament/api/tournaments/suggested`;
    try {
        const response = await axios.get(requestUrl, {
            params: useLegacyEndpoint ? { gameKey, limit } : { gameKey, maxResults: limit },
        });
        return response.data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getSuggestedTournaments;
